import React from 'react';
import { ArchiveBoxIcon, XMarkIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const ConfirmArchiveTaskModal = ({ isOpen, onClose, onConfirm, task, developers = [] }) => {
  if (!isOpen || !task) return null;

  // Функция для получения имени разработчика
  const getDeveloperName = (developerId) => {
    // Сначала ищем разработчика по ID
    const developer = developers.find((dev) => dev.id === developerId);
    if (developer) {
      return developer.name;
    }
    
    // Если не найден по ID, ищем по названию (для случаев когда developerId это имя)
    const developerByName = developers.find((dev) => dev.name === developerId);
    if (developerByName) {
      return developerByName.name;
    }
    
    // Если разработчик не найден, возвращаем ID как есть
    return developerId || "Не назначен";
  };

  // Функция для получения имени проекта
  const getProjectName = (projectId) => {
    // Если projectId это уже название проекта, возвращаем как есть
    if (typeof projectId === 'string' && !projectId.match(/^[0-9a-fA-F]{24}$/)) {
      return projectId;
    }
    
    // Иначе возвращаем как есть (для случаев когда это ID)
    return projectId || "Без проекта";
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 transform transition-all">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <ArchiveBoxIcon className="h-8 w-8 text-orange-500" />
            </div>
            <div className="ml-3">
              <h3 className="text-lg font-semibold text-gray-900">
                Архивировать задачу
              </h3>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-4">
            <p className="text-sm text-gray-600 mb-3">
              Вы собираетесь архивировать задачу:
            </p>
            <div className="bg-gray-50 border border-gray-200 rounded-md p-4">
              <h4 className="font-semibold text-gray-900 mb-2">{task.title}</h4>
              <div className="text-sm text-gray-600 space-y-1">
                <p><span className="font-medium">Часы:</span> {task.hours}</p>
                <p><span className="font-medium">Разработчик:</span> {getDeveloperName(task.developer)}</p>
                {task.project && (
                  <p><span className="font-medium">Проект:</span> {getProjectName(task.project)}</p>
                )}
              </div>
            </div>
          </div>

          <div className="bg-orange-50 border border-orange-200 rounded-md p-4 mb-4">
            <div className="flex items-start">
              <ExclamationTriangleIcon className="h-5 w-5 text-orange-500 mt-0.5 mr-2 flex-shrink-0" />
              <div className="text-sm text-orange-800">
                <p className="font-medium mb-1">Внимание!</p>
                <p>Задача будет перемещена в архив и удалена из основного списка. Это действие можно отменить позже в разделе "Архив".</p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
          >
            Отмена
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-sm font-medium text-white bg-orange-600 border border-transparent rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-colors"
          >
            Архивировать
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmArchiveTaskModal; 